/**
 * @blackjack/shared — core game types.
 *
 * FROZEN CONTRACT (Phase 1) — changing this is a deliberate version bump, not an
 * ad-hoc edit. See CLAUDE.md rule 2 and docs/GAME_SPEC.md.
 *
 * Money is ALWAYS integer cents (field names end in `Cents`). Never floats.
 * No `any` anywhere in this package.
 */
/**
 * Game constants. GAME_SPEC §7, §12. All money values are integer cents.
 */
export const STARTING_BALANCE_CENTS = 1000; // $10.00
export const MIN_BET_CENTS = 100; // $1.00
export const DEFAULT_DECKS = 6;
export const DEFAULT_TURN_TIMER_SECS = 15;
export const DEFAULT_DEALER_RULE = 'S17';
export const DEFAULT_NATURAL_PAYS_15 = false;
export const MIN_DECKS = 1;
export const MAX_DECKS = 8;
export const MIN_TURN_TIMER_SECS = 5;
export const MAX_TURN_TIMER_SECS = 30;
/** The default round configuration (GAME_SPEC §12 defaults). */
export const DEFAULT_ROUND_CONFIG = {
    decks: DEFAULT_DECKS,
    turnTimerSecs: DEFAULT_TURN_TIMER_SECS,
    dealerRule: DEFAULT_DEALER_RULE,
    naturalPays15: DEFAULT_NATURAL_PAYS_15,
};
/** Reserved participant id for the house (dealer) in a ranking. */
export const HOUSE_ID = '__house__';
//# sourceMappingURL=types.js.map